export const setBodyAuthClass = (status) => {
    if (!status) {
        document.body.classList.add("unauthenticated-user");
    } else {
        document.body.classList.remove("unauthenticated-user");
    }
};
